import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { ArrowLIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
};

const BackButton = (props: Props) => {
  const { onClick, sx, children } = props;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    onClick && onClick();
  };

  return (
    <Button
      sx={{
        width: '300px',
        height: '50px',
        mx: 'auto',
        my: 0,
        p: 1,
        textAlign: 'center',
        bgcolor: baseColors.darkGray,
        borderRadius: '25px',
        boxShadow: 2,
        position: 'relative',
        ...sx
      }}
      onClick={handleClick}
    >
      <ArrowLIcon style={{ position: 'absolute', left: 20 }} />
      <Typography
        variant="subtitle1"
        sx={{
          color: baseColors.white
        }}
      >
        {children ? children : '戻る'}
      </Typography>
    </Button>
  );
};

export default BackButton;
